import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Revista from "./views/Revista.vue";
import Anuario from "./views/Anuario.vue";
import Paquete from "./views/Paquete.vue";
import Cart from "./views/Cart.vue";
import Checkout from "./views/Checkout.vue";
import GuestCheckout from "./views/GuestCheckout.vue";
import GuestCheckoutSubscriptions from "./views/GuestCheckoutSubscriptions.vue";
import Thanks from "./views/Thanks.vue";
import ThanksPaypal from "./views/ThanksPaypal.vue";
import ThanksOpenpay from "./views/ThanksOpenpay.vue";
import ThanksStripe from "./views/ThanksStripe.vue";
import ThankYouPage from "./views/ThankYouPage.vue";
import ThanksOxxo from "./views/ThanksOxxo.vue";
import ThanksPaynet from "./views/ThanksPaynet.vue";
import ThanksSubscription from "./views/ThanksSubscription.vue";
import Product from "./views/Product.vue";
import Profile from "./views/Profile.vue";
import Login from "./views/Login.vue";
import ResetPassword from "./views/ResetPassword.vue";
import LoaderProduct from "./components/LoaderProduct.vue";
import CheckoutSubscriptions from "./views/CheckoutSubscriptions.vue";
import Magazine from "./views/Magazine.vue";
import SingleMagazine from "./views/SingleMagazine.vue";
import ViewerMagazine from "./views/ViewerMagazine.vue";
import Bases from "./views/Bases.vue";
import Privacity from "./views/Privacity.vue";
import TermConditions from "./views/TermConditions.vue";
import Faq from "./views/Faq.vue";
import Libros from "./views/Libros.vue";
import ChatLive from "./views/ChatLive.vue"

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/revistas",
      name: "revistas",
      component: Revista,
    },
    {
      path: "/anuarios",
      name: "anuarios",
      component: Anuario,
    },
    {
      path: "/paquetes",
      name: "paquetes",
      component: Paquete,
    },
    {
      path: "/cart",
      name: "cart",
      component: Cart,
    },
    {
      path: "/checkout",
      name: "checkout",
      component: Checkout,
    },
    {
      path: "/guestCheckout",
      name: "guestCheckout",
      component: GuestCheckout,
    },
    {
      path: "/guestCheckoutSubscriptions",
      name: "guestCheckoutSubscriptions",
      component: GuestCheckoutSubscriptions,
    },
    {
      path: "/thanks",
      name: "thanks",
      component: Thanks,
    },
    {
      path: "/thanksPaypal",
      name: "thanksPaypal",
      component: ThanksPaypal,
    },
    {
      path: "/thanksOpenpay",
      name: "thanksOpenpay",
      component: ThanksOpenpay,
    },
    {
      path: "/thanksStripe",
      name: "thanksStripe",
      component: ThanksStripe,
    },
    {
      path: "/ThankYouPage",
      name: "ThankYouPage",
      component: ThankYouPage,
    },
    {
      path: "/thanksoxxo",
      name: "thanksoxxo",
      component: ThanksOxxo,
    },
    {
      path: "/thanksForPay",
      name: "thanksForPay",
      component: ThanksPaynet,
    },
    {
      path: "/thanksForSubscribing",
      name: "thanksForSubscribing",
      component: ThanksSubscription,
    },
    {
      path: "/producto/:id",
      name: "producto",
      component: LoaderProduct,
      props: true,
    },
    {
      path: "/checkoutSubscription",
      name: "checkoutSubscription",
      component: CheckoutSubscriptions,
      props: true,
    },
    {
      path: "/profile/",
      name: "perfil",
      component: Profile,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "*",
      name: "catchAll",
      component: Home,
    },
    {
      path: "/resetpassword",
      name: "resetpassword",
      component: ResetPassword,
    },
    {
      path: "/Magazine",
      name: "magazine",
      component: Magazine,
      props: true,
    },
    {
      path: "/singleMagazine",
      name: "singleMagazine",
      component: SingleMagazine,
      props: true,
    },
    {
      path: "/viewerMagazine",
      name: "viewerMagazine",
      component: ViewerMagazine,
      props: true,
    },
    {
      path: "/bases",
      name: "bases",
      component: Bases,
    },
    {
      path: "/privacity",
      name: "privacity",
      component: Privacity,
    },
    {
      path: "/terms",
      name: "terms",
      component: TermConditions,
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq,
    },
    {
      path: "/libros",
      name: "libros",
      component: Libros,
    },
    {
      path: "/ChatLive",
      name : "chat",
      component : ChatLive,
    },
  ],
});
